<template>
  <div class="production_wrap">
    <div class="production_img">
      <div class="img_tit">AI智能运营管理</div>
      <div class="img_desc">利用人工智能技术实现数据驱动决策、流程优化，提升运营效率和智能化水平</div>
    </div>
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_left">
          <img src="../../assets/img/tupianright.png" alt="" />
        </div>
        <div class="inner_center" style="width:40%;">
          <div class="production_title">产品优势及特点</div>
          <div class="production_desc">
            "柳叶云"是一款专门为医疗器械行业定制的供应链管理软件。
          </div>
        </div>
        <div class="inner_right">
          <img src="../../assets/img/tupianleft.png" alt="" />
        </div>
      </div>
    </div>
    <p></p>
    <div class="production_core_scene"></div>
    <div class="production_card">
      <ProCard :procardList="procardList" />
    </div>
    <!-- 注释掉 procardList2 相关内容
    <div class="production_card">
      <ProCard2 :procardList="procardList2" />
    </div>
    -->
    <div class="advantage_out_wrap">
      <AdvantageCard />
    </div>
  </div>
</template>

<script>
import ProCard from './ProCard.vue'
import AdvantageCard from './AdvantageCard.vue'

export default {
  data() {
    return {
      procardList: [
        {
          tit: 'AI智能运营管理'
        }
      ]
    }
  },
  components: {
    ProCard,
    AdvantageCard
  }
}
</script>

<style lang="scss" scoped>
.production_wrap {
  width: 100%;
  
  .production_img {
    width: 100%;
    height: 600PX;
    @media screen and (max-width: 768PX) {
      height: 50vw;
    }
    background: url('../../assets/img/banner1.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    
    .img_tit {
      font-size: 60PX;
      font-weight: bold;
      max-width: 1200PX;
      text-align: center;
      padding: 0 20PX;
      @media screen and (max-width: 768PX) {
        font-size: 20PX;
      }
    }
    
    .img_desc {
      font-size: 28PX;
      margin-top: 20PX;
      max-width: 1200PX;
      text-align: center;
      padding: 0 20PX;
      line-height: 1.5;
      @media screen and (max-width: 768PX) {
        font-size: 14PX;
      }
    }
    
    .img_btn {
      width: 180PX;
      height: 50PX;
      border: solid 1PX rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30PX;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      
      &:hover {
        color: #fff;
        background: orange;
      }
      
      @media screen and (max-width: 768PX) {
        width: 80PX;
        height: 30PX;
        font-size: 14PX;
      }
    }
  }
  
  .production_title_wrap {
    width: 100%;
    margin-top: 50PX;
    position: relative;
    
    .production_inner {
      display: flex;
      justify-content: center;
      @media screen and (max-width: 768PX) {
        padding: 0 15PX;
        gap: 10PX;
      }
      
      .inner_left {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        @media screen and (max-width: 768PX) {
          flex: 1;
          justify-content: center;
        }
        img {
          width: 30%;
          @media screen and (max-width: 768PX) {
            width: 60PX;
          }
        }
      }
      
      .inner_center {
        width: 400PX;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 50PX;
        @media screen and (max-width: 768PX) {
          flex: 2;
          padding: 0 10PX;
          width: auto;
        }
        
        .production_title {
          font-size: 40PX;
          font-weight: bold;
          @media screen and (max-width: 768PX) {
            font-size: 18PX;
            text-align: center;
          }
        }
        
        .production_desc {
          font-size: 16PX;
          color: #787878;
          margin-top: 10PX;
          @media screen and (max-width: 768PX) {
            margin-top: 8PX;
            font-size: 13PX;
            text-align: center;
            line-height: 1.4;
          }
        }
      }
      
      .inner_right {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        @media screen and (max-width: 768PX) {
          flex: 1;
          justify-content: center;
        }
        img {
          width: 30%;
          @media screen and (max-width: 768PX) {
            width: 60PX;
          }
        }
      }
    }
  }
}
</style> 